import React from 'react'
import { mutationDeleteUser } from '../../../../api/mutations'
import { DeleteIconButton } from '../../../../components/DeleteIconButton/DeleteIconButton'
import { useInvalidatingMutation } from '../../../../hooks/useInvalidatingMutation'
import { AxiosResponse } from 'axios'
import { IUser } from '../../../../api/types/user'
import { usersQueryKey } from '../../../../api/queries'

interface Props {
  user: IUser
}

export const DeleteUser: React.FC<Props> = ({ user }) => {
  const { mutate: handleDeleteUser, isLoading: isMutating } = useInvalidatingMutation<
    AxiosResponse,
    number
  >((id: number) => mutationDeleteUser(id), [usersQueryKey()])
  return (
    <DeleteIconButton
      confirmationBody={
        <div>
          Delete user <span className="font-weight-bold">{user.username}</span> ?
        </div>
      }
      onClick={() => handleDeleteUser(user.id)}
      isLoading={isMutating}
    />
  )
}
